export const LESSON_COLUMNS =
  'grid-cols-[40px_minmax(180px,2fr)_minmax(0,3fr)_minmax(0,3fr)_minmax(120px,1.5fr)] lg:grid-cols-[40px_minmax(220px,2fr)_minmax(0,3fr)_minmax(0,3fr)_minmax(150px,1.5fr)] xl:grid-cols-[40px_minmax(235px,2fr)_minmax(0,3fr)_minmax(0,3fr)_minmax(172px,1.5fr)]';

export const NOTES_COLUMNS =
  'grid-cols-[40px_minmax(180px,2fr)_minmax(0,7.5fr)] lg:grid-cols-[40px_minmax(220px,2fr)_minmax(0,7.5fr)] xl:grid-cols-[40px_minmax(235px,2fr)_minmax(0,7.5fr)]';

export const DAY_CARD =
  'overflow-hidden rounded-2xl bg-card shadow-card contrast:border contrast:border-border';

export const HEADER_CELL =
  'flex h-12 items-center bg-on-primary-surface pr-3 pl-5 text-body-14 text-foreground';

export const CELL_BORDER = 'min-h-12 border-t border-r border-border-table';

export const LAST_CELL_BORDER = 'min-h-12 border-t border-border-table';

export const TEXT_CELL_PADDING =
  'flex-1 justify-center py-2 pr-3 pl-4 text-foreground';
